import { Col, Row } from 'reactstrap';
import TableActions from 'components/layouts/table';
import Table, { useTable } from 'common/components/table';
import EnumsDropdown from '../../Dropdown';

const VesselPrefixes = () => {
  const table = useTable({
    label: 'vessel_prefixes',
    columns: [
      {
        header: 'Name',
        key: 'name',
        type: 'string',
        sort: true,
        width: 2
      },
      {
        header: 'Description',
        key: 'description',
        type: 'string',
        sort: true
      }
    ]
  });

  return (
    <Row className="vessel-prefixes-table">
      <Col xs={12} className="mb-6 mt-n1">
        <TableActions
          documentTitle="Vessel Prefixes"
          title="Enums"
          dropdown={<EnumsDropdown />}
          actions={[{ type: 'search' }]}
        />
      </Col>
      <Col xs={12}>
        <Table
          loader
          rows={{
            updated_by_organization: data => (
              <div>{data.updated_by_organization ? 'YES' : 'NO'}</div>
            ),
            hidden: data => <div>{data.hidden ? 'YES' : 'NO'}</div>,
            hidden_by_default: data => <div>{data.hidden_by_default ? 'YES' : 'NO'}</div>
          }}
          {...table}
        />
      </Col>
    </Row>
  );
};

export default VesselPrefixes;
